import type { FunctionComponent } from 'preact';

import type { FacetCommonProps } from '../baseFacet';
import advancedColorFacet from './advancedColorFacet';
import rangedFacet from './rangedFacet';
import selectFacet from './selectFacet';
import simpleFacet from './simpleFacet';
import sizeFacet from './sizeFacet';
import toggleFacet from './toggleFacet';

export type FacetTypeName =
  | 'advancedColorFacet'
  | 'selectFacet'
  | 'simpleFacet'
  | 'sizeFacet'
  | 'rangedFacet'
  | 'toggleFacet';

const facetTypeToComponent: Record<FacetTypeName, FunctionComponent<FacetCommonProps>> = {
  advancedColorFacet,
  selectFacet,
  simpleFacet,
  sizeFacet,
  rangedFacet,
  toggleFacet,
};

export default facetTypeToComponent;
